type scourierParms = {
  name: string;
  code: string;
};

export const courierData: {
  [key: string]: scourierParms[];
} = require('../asset/data/offline_deliverylogis.json');

export const getCourierCode = (name: string) => {
  const result = courierData['company'].find((option) => option.name === name);
  if (result !== undefined) return result.code;
  return '';
};
export const getCourierName = (code: string) => {
  const result = courierData['company'].find((option) => option.code === code);
  if (result !== undefined) return result.name;
  return '';
};
